import React, { createContext, useContext, forwardRef, useEffect, useState, Fragment, useRef } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var classnames = {exports: {}};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames));

var classNames = classnames.exports;

var dataAttrRe = /^(data-.*)$/;
var filterDataAttrs = function (props) {
    var filteredProps = {};
    for (var prop in props) {
        if (Object.prototype.hasOwnProperty.call(props, prop) &&
            dataAttrRe.test(prop)) {
            filteredProps[prop] = props[prop];
        }
    }
    return filteredProps;
};

var camelcase = {exports: {}};

const UPPERCASE = /[\p{Lu}]/u;
const LOWERCASE = /[\p{Ll}]/u;
const LEADING_CAPITAL = /^[\p{Lu}](?![\p{Lu}])/gu;
const IDENTIFIER = /([\p{Alpha}\p{N}_]|$)/u;
const SEPARATORS = /[_.\- ]+/;

const LEADING_SEPARATORS = new RegExp('^' + SEPARATORS.source);
const SEPARATORS_AND_IDENTIFIER = new RegExp(SEPARATORS.source + IDENTIFIER.source, 'gu');
const NUMBERS_AND_IDENTIFIER = new RegExp('\\d+' + IDENTIFIER.source, 'gu');

const preserveCamelCase = (string, locale) => {
	let isLastCharLower = false;
	let isLastCharUpper = false;
	let isLastLastCharUpper = false;

	for (let i = 0; i < string.length; i++) {
		const character = string[i];

		if (isLastCharLower && UPPERCASE.test(character)) {
			string = string.slice(0, i) + '-' + string.slice(i);
			isLastCharLower = false;
			isLastLastCharUpper = isLastCharUpper;
			isLastCharUpper = true;
			i++;
		} else if (isLastCharUpper && isLastLastCharUpper && LOWERCASE.test(character)) {
			string = string.slice(0, i - 1) + '-' + string.slice(i - 1);
			isLastLastCharUpper = isLastCharUpper;
			isLastCharUpper = false;
			isLastCharLower = true;
		} else {
			isLastCharLower = character.toLocaleLowerCase(locale) === character && character.toLocaleUpperCase(locale) !== character;
			isLastLastCharUpper = isLastCharUpper;
			isLastCharUpper = character.toLocaleUpperCase(locale) === character && character.toLocaleLowerCase(locale) !== character;
		}
	}

	return string;
};

const preserveConsecutiveUppercase = input => {
	LEADING_CAPITAL.lastIndex = 0;

	return input.replace(LEADING_CAPITAL, m1 => m1.toLowerCase());
};

const postProcess = (input, options) => {
	SEPARATORS_AND_IDENTIFIER.lastIndex = 0;
	NUMBERS_AND_IDENTIFIER.lastIndex = 0;

	return input.replace(SEPARATORS_AND_IDENTIFIER, (_, identifier) => identifier.toLocaleUpperCase(options.locale))
		.replace(NUMBERS_AND_IDENTIFIER, m => m.toLocaleUpperCase(options.locale));
};

const camelCase = (input, options) => {
	if (!(typeof input === 'string' || Array.isArray(input))) {
		throw new TypeError('Expected the input to be `string | string[]`');
	}

	options = {
		pascalCase: false,
		preserveConsecutiveUppercase: false,
		...options
	};

	if (Array.isArray(input)) {
		input = input.map(x => x.trim())
			.filter(x => x.length)
			.join('-');
	} else {
		input = input.trim();
	}

	if (input.length === 0) {
		return '';
	}

	if (input.length === 1) {
		return options.pascalCase ? input.toLocaleUpperCase(options.locale) : input.toLocaleLowerCase(options.locale);
	}

	const hasUpperCase = input !== input.toLocaleLowerCase(options.locale);

	if (hasUpperCase) {
		input = preserveCamelCase(input, options.locale);
	}

	input = input.replace(LEADING_SEPARATORS, '');

	if (options.preserveConsecutiveUppercase) {
		input = preserveConsecutiveUppercase(input);
	} else {
		input = input.toLocaleLowerCase();
	}

	if (options.pascalCase) {
		input = input.charAt(0).toLocaleUpperCase(options.locale) + input.slice(1);
	}

	return postProcess(input, options);
};

camelcase.exports = camelCase;
// TODO: Remove this for the next major release
camelcase.exports.default = camelCase;

var camelCase$1 = camelcase.exports;

/**
 * Suffixes a modifier value onto the end of a className, converting it to
 * pascal case. i.e. turns suffixModifier("MyComponent--display", display)
 * returns MyComponent--displayBlock.
 *
 * @param rootClassName The root className to append the suffix onto
 * @param suffix The suffix to convert into pascal case.
 */
var suffixModifier = function (rootClassName, suffix) {
    return "".concat(rootClassName).concat(camelCase$1(suffix, {
        pascalCase: true
    }));
};

/**
 * Use `Align` to align items horizontally or vertically.
 */
var Align = function (_a) {
    var _b;
    var children = _a.children, _c = _a.horizontal, horizontal = _c === void 0 ? "left" : _c, _d = _a.isDebugVisible, isDebugVisible = _d === void 0 ? false : _d, _e = _a.vertical, vertical = _e === void 0 ? "top" : _e, props = __rest(_a, ["children", "horizontal", "isDebugVisible", "vertical"]);
    var wrappedChildren = React.Children.map(children, function (child, i) { return (React.createElement(AlignItem, { key: i }, child)); });
    return (React.createElement("div", __assign({ className: classNames((_b = {},
            _b["arc-Align"] = true,
            _b[suffixModifier("arc-Align--horizontal", horizontal)] = horizontal !== "left",
            _b["arc-Align--debugVisible"] = isDebugVisible,
            _b[suffixModifier("arc-Align--vertical", vertical)] = vertical !== "top",
            _b)) }, filterDataAttrs(props)), wrappedChildren));
};
var AlignItem = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "arc-Align-item" }, children);
};

/**
 * Use `Base` as the root component of the arc system.
 */
var Base = function (_a) {
    var _b = _a.brand, brand = _b === void 0 ? "bt" : _b, children = _a.children, props = __rest(_a, ["brand", "children"]);
    return (React.createElement("div", __assign({ className: "arc".concat(brand ? " arc-".concat(brand) : "") }, filterDataAttrs(props)), children));
};

var defaultContext$3 = { surface: "light" };
var Context$3 = createContext(defaultContext$3);
var Provider$4 = Context$3.Provider;
/**
 * Use `Surface` to compose content using the Arc system.
 */
var Surface = function (_a) {
    var _b;
    var background = _a.background, children = _a.children, _c = _a.growVertically, growVertically = _c === void 0 ? false : _c, padding = _a.padding, paddingHorizontal = _a.paddingHorizontal, paddingVertical = _a.paddingVertical, props = __rest(_a, ["background", "children", "growVertically", "padding", "paddingHorizontal", "paddingVertical"]);
    var surface = "light";
    if (background === "black" ||
        background === "brand" ||
        background === "brand-flat" ||
        background === "dark" ||
        background === "darker") {
        surface = "dark";
    }
    return (React.createElement(Provider$4, { value: { surface: surface } },
        React.createElement("div", __assign({ className: classNames((_b = {
                    "arc-Surface": true
                },
                _b["arc-Surface--".concat(background &&
                    camelCase$1(background), "Background")] = background,
                _b["arc-Surface--growVertically"] = growVertically,
                _b["arc-Surface--padding".concat(padding)] = padding,
                _b["arc-Surface--paddingHorizontal".concat(paddingHorizontal)] = paddingHorizontal,
                _b["arc-Surface--paddingVertical".concat(paddingVertical)] = paddingVertical,
                _b)) }, filterDataAttrs(props)), children)));
};
var backgroundsShared = [
    "black",
    "brand",
    "brand-flat",
    "dark",
    "darker",
    "coral",
    "turquoise",
    "light",
    "lighter",
    "white"
];
__spreadArray([], backgroundsShared, true);
__spreadArray([], backgroundsShared, true);

/**
 * Use `BrandLogo` to display the brand logo.
 */
var BrandLogo = function (_a) {
    var _b;
    var _c = _a.color, color = _c === void 0 ? "auto" : _c, label = _a.label, _d = _a.size, size = _d === void 0 ? 34 : _d, subBrand = _a.subBrand, props = __rest(_a, ["color", "label", "size", "subBrand"]);
    var surface = useContext(Context$3).surface;
    return (React.createElement("div", __assign({ className: classNames((_b = {
                "arc-BrandLogo": true,
                "arc-BrandLogo--colorBrand": color === "brand",
                "arc-BrandLogo--onDarkSurface": surface === "dark"
            },
            _b[suffixModifier("arc-BrandLogo--subBrand", subBrand || "")] = subBrand,
            _b)), style: {
            width: size !== 34 ? size : undefined
        } }, filterDataAttrs(props)), label ? React.createElement("span", { className: "arc-BrandLogo-text" }, label) : null));
};

/**
 * Do not edit directly
 * Generated file
 */
const ArcBreakpointM = 768;
const ArcBreakpointL = 1024;
const iconsSelected = [
  "bt3GFill",
  "bt4GFill",
  "bt5GFill",
  "btAccessibilityFill",
  "btAddFill",
  "btAlertFill",
  "btAlertTriangleFill",
  "btAnswerPointFill",
  "btArchitectureFill",
  "btArchiveFill",
  "btArrowAltDownFill",
  "btArrowAltLeftFill",
  "btArrowAltLeftRightFill",
  "btArrowAltRightFill",
  "btArrowAltUpFill",
  "btArrowDownFill",
  "btArrowLeftFill",
  "btArrowLeftRightFill",
  "btArrowRightFill",
  "btArrowUpFill",
  "btAttachmentAltFill",
  "btAttachmentFill",
  "btBagFill",
  "btBasketFill",
  "btBinFill",
  "btBlockedNumberFill",
  "btBoatFill",
  "btBroadbandFill",
  "btBuildingFill",
  "btBurgerMenuFill",
  "btCakeFill",
  "btCalenderAcceptedFill",
  "btCalenderAddEventFill",
  "btCalenderFill",
  "btCalenderPaymentPlanAltFill",
  "btCalenderPaymentPlanFill",
  "btCalenderSpecialDateFill",
  "btCallRoutingFill",
  "btCallerIdFill",
  "btChatFill",
  "btChatMessageFill",
  "btChatTypingFill",
  "btClipboardFill",
  "btClipboardTickFill",
  "btClockFill",
  "btCloudAlertFill",
  "btCloudDesktopFill",
  "btCloudFill",
  "btCloudLinkFill",
  "btCloudMeetingFill",
  "btCloudPhoneFill",
  "btCloudSecurityFill",
  "btCloudUploadFill",
  "btCloudUserFill",
  "btCollapseFill",
  "btCompareFill",
  "btComputerChipFill",
  "btConnectedCareFill",
  "btContactDetailsFill",
  "btContactNoDetailsFill",
  "btContactsFill",
  "btCreditCardFill",
  "btCrossAlt2pxFill",
  "btCrossAltFill",
  "btCrossFill",
  "btDashboardFill",
  "btDepositFill",
  "btDesignFill",
  "btDeskPhoneFill",
  "btDetailsFill",
  "btDetailsGroupFill",
  "btDexterityFill",
  "btDialPadFill",
  "btDialPadWithHandFill",
  "btDialledNumberDestinationFill",
  "btDigitalCollaborationFill",
  "btDisabilityFill",
  "btDiscountFill",
  "btDivertOnBusyFill",
  "btDocumentAndPencilFill",
  "btDocumentArticleFill",
  "btDocumentBillsFill",
  "btDocumentDownloadFill",
  "btDocumentFill",
  "btDocumentPdfFill",
  "btDocumentWithCopyCrossedOutFill",
  "btDocumentWithCopyFill",
  "btDynamicCollaborationFill",
  "btEducationFill",
  "btEmailReadFill",
  "btEmailUnreadFill",
  "btEngagedFill",
  "btEthernetFill",
  "btFaceHappyFill",
  "btFaceNeutralFill",
  "btFaceSadFill",
  "btFaceVeryHappyFill",
  "btFirstAidFill",
  "btFolderFill",
  "btGamingFill",
  "btGenderFemaleAndMaleFill",
  "btGenderFemaleFill",
  "btGenderMaleFill",
  "btGenderNeutralFill",
  "btGiftFill",
  "btGlobalConnectivityFill",
  "btGlobeFill",
  "btGlossaryFill",
  "btGondolaFill",
  "btGraphBarAndPlotFill",
  "btGraphBarChartFill",
  "btGraphDownFill",
  "btGraphUpAndDownFill",
  "btGraphUpFill",
  "btHeadsetFill",
  "btHeartBrokenFill",
  "btHeartCareFill",
  "btHeartFill",
  "btHoldingHeartFill",
  "btHomeFill",
  "btHomeTechExpertFill",
  "btHometownFill",
  "btHubAndMobileFill",
  "btHubFill",
  "btHubOldFill",
  "btIpFill",
  "btIPv6Fill",
  "btIdeaFill",
  "btInfoFill",
  "btJsonFill",
  "btJigsawFill",
  "btJourneyFill",
  "btKeyFill",
  "btKnifeAndForkFill",
  "btLanFill",
  "btLaptopAndMobileFill",
  "btLaptopConnectAndShareFill",
  "btLaptopDetectionFill",
  "btLaptopFill",
  "btLaptopSecureFill",
  "btLaptopVideoConferenceFill",
  "btLaptopUsersFill",
  "btLayoutGridLargeFill",
  "btLayoutGridMediumFill",
  "btLayoutGridSmallFill",
  "btLayoutRowsLargeFill",
  "btLayoutRowsMediumFill",
  "btLayoutRowsSmallFill",
  "btLeadershipFill",
  "btLinkFill",
  "btLiteracyNumeracyFill",
  "btLocationFill",
  "btLockedFill",
  "btLogoutFill",
  "btMedalFill",
  "btMedalWithStarFill",
  "btMeetingSpaceFill",
  "btMegaphoneFill",
  "btMicrophoneFill",
  "btMobileFill",
  "btMobileTransferCallFill",
  "btMobileWithHandFill",
  "btMobilityFill",
  "btMoneyFill",
  "btMonitorFill",
  "btMonitorTickFill",
  "btMoonFill",
  "btMouseFill",
  "btNamingFill",
  "btNewWindowFill",
  "btNoHearingFill",
  "btNoHearingOrSpeechFill",
  "btNoSpeechFill",
  "btNoViewFill",
  "btNotificationFill",
  "btPaperTowelFill",
  "btPasswordFIll",
  "btPaymentMethodFill",
  "btPayphoneFill",
  "btPhoneBarredFill",
  "btPhoneFill",
  "btPictureFill",
  "btPinAltFill",
  "btPinFill",
  "btPlaneFill",
  "btPlanningFill",
  "btPlantFill",
  "btPlayFill",
  "btPodcastFill",
  "btPresentationFill",
  "btPriceFill",
  "btPrinterFill",
  "btProcessFill",
  "btProcessMiningFill",
  "btProcessRolesFill",
  "btProportionalCallDistributionFill",
  "btQuestionFill",
  "btRecyclingFill",
  "btRefreshFill",
  "btRefundFill",
  "btReleaseFill",
  "btResolution4KFill",
  "btResolutionHdFill",
  "btResolutionSdFill",
  "btScaleFill",
  "btSearchFill",
  "btServerFill",
  "btSettingsAlt2Fill",
  "btSettingsAltFill",
  "btSettingsFill",
  "btShieldAddFill",
  "btShieldFill",
  "btShieldQuestionMarkFIll",
  "btShieldSecurityFill",
  "btShieldTickFill",
  "btShipFill",
  "btSignalFill",
  "btSignatureFill",
  "btSignpostFill",
  "btSimFill",
  "btSimpleFill",
  "btSkiingFill",
  "btSkisFill",
  "btSnowboardingFill",
  "btSpannerFill",
  "btSpeakerFullVolumeFill",
  "btSpeakerHalfVolumeFill",
  "btSpeakerLowVolumeFill",
  "btSpeakerMuteFill",
  "btSpeedFasterFill",
  "btSpeedFastestFill",
  "btSpeedSlowFill",
  "btSportFootballFill",
  "btStarFill",
  "btStopFill",
  "btStopAltFill",
  "btSuitcaseFill",
  "btSunFill",
  "btSwitchFill",
  "btTvArialFill",
  "btTvFill",
  "btTvAndHubFill",
  "btTvAndHubAndPhoneFill",
  "btTabletFill",
  "btTabletWithKeyboardFill",
  "btTagFill",
  "btTaxonomyFill",
  "btTechBarFill",
  "btTelemarkFill",
  "btThumbsDownFill",
  "btThumbsUpFill",
  "btTickAlt2pxFill",
  "btTickFill",
  "btTickVariantFill",
  "btTree1Fill",
  "btTree2Fill",
  "btTrophyFill",
  "btUkFill",
  "btUsbFill",
  "btUnlockedFill",
  "btUserAddFill",
  "btUserCloudFill",
  "btUserDuplicateProfileFill",
  "btUserFill",
  "btUserGroupsFill",
  "btUserParentAndChildFill",
  "btUserWithQuestionmarkFill",
  "btVanFill",
  "btViewFill",
  "btVirusFill",
  "btWholeHomeWifiFill",
  "btWiFiFill",
  "btWizardFill",
  "btWorkstationFill"
];

/**
 * Use `Icon` to display brand iconography.
 */
var Icon = function (_a) {
    var _b;
    var _c = _a.color, color = _c === void 0 ? "auto" : _c, icon = _a.icon, _d = _a.isInline, isInline = _d === void 0 ? false : _d, _e = _a.isSelected, isSelected = _e === void 0 ? false : _e, label = _a.label, size = _a.size, props = __rest(_a, ["color", "icon", "isInline", "isSelected", "label", "size"]);
    var surface = useContext(Context$3).surface;
    return (React.createElement("span", __assign({ "aria-label": label, className: classNames((_b = {},
            _b["arc-Icon"] = true,
            _b[suffixModifier("arc-Icon--color", color)] = color !== "auto",
            _b["arc-Icon--".concat(icon).concat(isSelected && iconsSelected.includes("".concat(icon, "Fill")) ? "Fill" : "")] = icon,
            _b["arc-Icon--inline"] = isInline,
            _b["arc-Icon--onDarkSurface"] = surface === "dark",
            _b)), role: label ? "img" : undefined, style: {
            height: size,
            width: size
        } }, filterDataAttrs(props))));
};

/**
 * Use `Button` to allow users to take actions with clicks and taps.
 */
var Button = forwardRef(function (_a, ref) {
    var _b;
    var ariaLabel = _a.ariaLabel, _c = _a.fill, fill = _c === void 0 ? "solid" : _c, href = _a.href, icon = _a.icon, _d = _a.iconPosition, iconPosition = _d === void 0 ? "afterText" : _d, id = _a.id, _e = _a.isDisabled, isDisabled = _e === void 0 ? false : _e, _f = _a.isDisplayBlock, isDisplayBlock = _f === void 0 ? false : _f, _g = _a.isFullWidth, isFullWidth = _g === void 0 ? false : _g, label = _a.label, onClick = _a.onClick, rel = _a.rel, supportingText = _a.supportingText, target = _a.target, type = _a.type, props = __rest(_a, ["ariaLabel", "fill", "href", "icon", "iconPosition", "id", "isDisabled", "isDisplayBlock", "isFullWidth", "label", "onClick", "rel", "supportingText", "target", "type"]);
    var surface = useContext(Context$3).surface;
    var buttonClasses = classNames((_b = {
            "arc-Button": true,
            "arc-Button--displayBlock": isDisplayBlock
        },
        _b[suffixModifier("arc-Button--fill", fill)] = fill !== "solid",
        _b["arc-Button--fullWidth"] = isFullWidth,
        _b[suffixModifier("arc-Button--icon", iconPosition.replace("icon", ""))] = (icon || fill === "flat") &&
            iconPosition &&
            iconPosition !== "afterText",
        _b["arc-Button--hasSupportingText"] = supportingText,
        _b["arc-Button--onDarkSurface"] = surface === "dark",
        _b));
    var commonProps = __assign({ id: id, onClick: onClick, ref: ref }, filterDataAttrs(props));
    var buttonText = supportingText ? (React.createElement("span", null,
        React.createElement("span", { className: "arc-Button-text" }, label),
        React.createElement("span", { className: "arc-Button-supportingText" }, supportingText))) : (React.createElement("span", { className: "arc-Button-text" }, label));
    var buttonIcon = icon || fill === "flat" ? (React.createElement(ButtonIcon, { icon: icon, isChevron: !icon && fill === "flat", isBeforeText: iconPosition === "beforeText" })) : null;
    if (href && !isDisabled) {
        return (React.createElement("a", __assign({}, commonProps, { "aria-label": ariaLabel, className: buttonClasses, href: href, rel: rel, target: target }),
            React.createElement("span", { className: "arc-Button-inner" },
                buttonText,
                buttonIcon)));
    }
    return (React.createElement("button", __assign({}, commonProps, { "aria-label": ariaLabel, className: buttonClasses, disabled: isDisabled, type: type }),
        React.createElement("span", { className: "arc-Button-inner" },
            buttonText,
            buttonIcon)));
});
var ButtonIcon = function (_a) {
    var icon = _a.icon, isChevron = _a.isChevron, isBeforeText = _a.isBeforeText;
    return (React.createElement("span", { className: classNames({
            "arc-Button-icon": true,
            "arc-Button-icon--chevron": isChevron
        }) }, isChevron ? (React.createElement(Icon, { icon: "btChevron".concat(isBeforeText ? "Left" : "Right", "2px") })) : (React.createElement(Icon, { icon: icon }))));
};

/**
 * Use `Image` to render a single image, or set of images, with support for
 * image fitting and art direction.
 */
var Image = function (_a) {
    var _b;
    var alt = _a.alt, _c = _a.anchor, anchor = _c === void 0 ? "C" : _c, children = _a.children, fillColor = _a.fillColor, fit = _a.fit, height = _a.height, loading = _a.loading, overlay = _a.overlay, sizes = _a.sizes, src = _a.src, srcSet = _a.srcSet, width = _a.width, props = __rest(_a, ["alt", "anchor", "children", "fillColor", "fit", "height", "loading", "overlay", "sizes", "src", "srcSet", "width"]);
    useEffect(function () {
        React.Children.map(children, function (item) {
            if (item && item.type !== ImageSource) {
                throw new Error("Illegal child passed to <Image />. Ensure to only use <Image.Source />.");
            }
        });
    }, [children]);
    var img = (React.createElement("img", { className: "arc-Image-img", alt: alt, height: fit === "cover" ? undefined : height, loading: loading, sizes: children ? undefined : sizes, src: src, srcSet: children ? undefined : srcSet, width: fit === "cover" ? undefined : width }));
    return (React.createElement("div", __assign({ className: classNames((_b = {
                "arc-Image": true,
                "arc-Image--cover": fit === "cover"
            },
            _b["arc-Image--anchor".concat(anchor)] = fit === "cover",
            _b[suffixModifier("arc-Image--overlay", overlay || "")] = overlay,
            _b)), style: __assign(__assign(__assign({}, (fillColor && { backgroundColor: fillColor })), (fit === "cover" && height ? { height: "".concat(height, "px") } : null)), (fit === "cover" && width ? { width: "".concat(width, "px") } : null)) }, filterDataAttrs(props)), children ? (React.createElement("picture", null,
        children,
        " ",
        img)) : (React.createElement(React.Fragment, null, img))));
};
var ImageSource = function (_a) {
    var height = _a.height, media = _a.media, srcSet = _a.srcSet, sizes = _a.sizes, type = _a.type; _a.width; var props = __rest(_a, ["height", "media", "srcSet", "sizes", "type", "width"]);
    return (React.createElement("source", __assign({ height: height, media: media, sizes: sizes, srcSet: srcSet, type: type }, filterDataAttrs(props))));
};
ImageSource.displayName = "Image.Source";
Image.Source = ImageSource;

/**
 * Use `Heading` to display heading text.
 */
var Heading = function (_a) {
    var _b;
    var _c = _a.align, align = _c === void 0 ? "left" : _c, _d = _a.casing, casing = _d === void 0 ? "auto" : _d, children = _a.children, _e = _a.color, color = _e === void 0 ? "auto" : _e, level = _a.level, size = _a.size, props = __rest(_a, ["align", "casing", "children", "color", "level", "size"]);
    var surface = useContext(Context$3).surface;
    var Element = "span";
    if (level) {
        Element = "h".concat(level);
    }
    return (React.createElement(Element, __assign({ className: classNames((_b = {
                "arc-Heading": true
            },
            _b[suffixModifier("arc-Heading--align", align)] = align && align !== "left",
            _b["arc-Heading--size".concat(size && size.toUpperCase())] = size,
            _b["arc-Heading--casingNone"] = casing === "none",
            _b["arc-Heading--colorBrand"] = color === "brand",
            _b["arc-Heading--onDarkSurface"] = surface === "dark",
            _b)) }, filterDataAttrs(props)), children));
};
var HeadingProposition = function (_a) {
    var children = _a.children;
    return React.createElement("span", { className: "arc-Heading-proposition" }, children);
};
HeadingProposition.displayName = "Heading.Proposition";
Heading.Proposition = HeadingProposition;

/**
 * Optionally define ariaDescribedBy if errorMessage or helper exist.
 */
var useAriaDescribedby = function (_a) {
    var id = _a.id, _b = _a.idError, idError = _b === void 0 ? "".concat(id, "-error") : _b, _c = _a.idHelper, idHelper = _c === void 0 ? "".concat(id, "-helper") : _c, errorMessage = _a.errorMessage, helper = _a.helper;
    if (!id) {
        return {
            ariaDescribedby: undefined,
            idHelper: undefined,
            idError: undefined
        };
    }
    var ariaDescribedbyArr = [];
    if (errorMessage) {
        ariaDescribedbyArr.push(idError);
    }
    if (helper) {
        ariaDescribedbyArr.push(idHelper);
    }
    var ariaDescribedby = ariaDescribedbyArr.length > 0 ? ariaDescribedbyArr.join(" ") : undefined;
    return { ariaDescribedby: ariaDescribedby, idError: idError, idHelper: idHelper };
};

/**
 * Detect interaction mode
 */
var useInteractionMode = function () {
    var _a = useState("pointer"), interactionMode = _a[0], setInteractionMode = _a[1];
    useEffect(function () {
        var onKeyDown = function (event) {
            if (event.altKey || event.ctrlKey || event.metaKey) {
                return;
            }
            setInteractionMode("keyboard");
        };
        var onPointerDown = function () {
            setInteractionMode("pointer");
        };
        if (typeof window !== "undefined") {
            document.addEventListener("keydown", onKeyDown, true);
            document.addEventListener("click", onPointerDown, true);
        }
        return function () {
            if (typeof window !== "undefined") {
                document.removeEventListener("keydown", onKeyDown);
                document.removeEventListener("click", onPointerDown);
            }
        };
    }, []);
    return { interactionMode: interactionMode };
};

/**
 * @typedef MediaQueryOutputs
 * @param {boolean} matches - does the document match the media query?
 */
/**
 * Handle with care!
 *
 * If you need to change something in the browser based on @media query, you
 * probably don’t need this hook. Use CSS media queries instead.
 *
 * Sometimes UI requirements are not achievable with CSS media queries alone. In
 * these rare cases, use this hook to make media query matches available
 * to React JavaScript code.
 *
 * @param {string} mediaQuery - the media query to parse
 * @returns {MediaQueryOutputs}
 */
var useMediaQuery = function (mediaQuery) {
    var mediaQueryList = typeof window !== "undefined" ? window.matchMedia(mediaQuery) : undefined;
    var _a = useState(false), matches = _a[0], setMatches = _a[1];
    useEffect(function () {
        setMatches(typeof window !== "undefined"
            ? window.matchMedia(mediaQuery).matches
            : false);
    }, [mediaQuery]);
    useEffect(function () {
        var onMatchMedia = function (event) { return setMatches(event.matches); };
        // Using deprecated addListener methods here for IE & Safari 13 support
        if (mediaQueryList) {
            mediaQueryList.addListener(onMatchMedia);
        }
        return function () { return mediaQueryList && mediaQueryList.removeListener(onMatchMedia); };
    }, [mediaQueryList]);
    return matches;
};

/**
 * Infer the correct inputMode, pattern and type if specifying a `number` type.
 */
var useNumericInput = function (props) {
    var type = props.type === "number" ? "text" : props.type;
    var inputMode = props.inputMode;
    if (!props.inputMode) {
        if (props.type === "email") {
            inputMode = "email";
        }
        else if (props.type === "number") {
            inputMode = "numeric";
        }
        else if (props.type === "tel") {
            inputMode = "tel";
        }
        else if (props.type === "url") {
            inputMode = "url";
        }
    }
    var pattern = props.pattern;
    if (!props.pattern && props.type === "number") {
        pattern = "[0-9]*";
    }
    return { inputMode: inputMode, pattern: pattern, type: type };
};

var handleLinkClick = function (_a) {
    var handler = _a.handler, _b = _a.preventDefault, preventDefault = _b === void 0 ? true : _b;
    return function (e) {
        if (preventDefault && handler) {
            e.preventDefault();
        }
        if (handler) {
            handler();
        }
    };
};

/**
 * Use `Card` to contain content and actions about a single subject.
 */
var Card = function (_a) {
    var _b;
    var actionId = _a.actionId, _c = _a.actionLabel, actionLabel = _c === void 0 ? "Read more" : _c, children = _a.children, _d = _a.fill, fill = _d === void 0 ? "solid" : _d, href = _a.href, imageAlt = _a.imageAlt, imageHeight = _a.imageHeight, imageLoading = _a.imageLoading, imageSrc = _a.imageSrc, imageSrcSet = _a.imageSrcSet, linkData = _a.linkData, minHeight = _a.minHeight, onClick = _a.onClick, target = _a.target, title = _a.title, _e = _a.titleSize, titleSize = _e === void 0 ? "s" : _e, props = __rest(_a, ["actionId", "actionLabel", "children", "fill", "href", "imageAlt", "imageHeight", "imageLoading", "imageSrc", "imageSrcSet", "linkData", "minHeight", "onClick", "target", "title", "titleSize"]);
    var surface = useContext(Context$3).surface;
    var interactionMode = useInteractionMode().interactionMode;
    var Wrapper = function (_a) {
        var children = _a.children;
        return fill === "outlined" || fill === "neutral" ? (React.createElement("div", null, children)) : (React.createElement(Surface, { background: surface === "dark" ? "white" : "darker" }, children));
    };
    var coverImage = imageSrc && (React.createElement(CardImage, { alt: imageAlt, height: imageHeight, loading: imageLoading, src: imageSrc, srcSet: imageSrcSet }));
    return (React.createElement("div", __assign({ className: classNames((_b = {
                "arc-Card": true,
                "arc-Card--onDarkSurface": surface === "dark"
            },
            _b[suffixModifier("arc-Card--fill", fill)] = fill !== "solid",
            _b["arc-is-".concat(interactionMode, "InteractionMode")] = interactionMode,
            _b)) }, filterDataAttrs(props)),
        React.createElement(Wrapper, null,
            React.createElement("div", { className: "arc-Card-inner", style: { minHeight: minHeight } },
                React.createElement("div", { className: "arc-Card-header" },
                    React.createElement("div", { className: "arc-Card-title" },
                        React.createElement(Heading, { size: titleSize },
                            React.createElement(CardLink, { stretch: true, onClick: onClick, actionId: actionId, fill: fill, href: href, linkData: linkData, target: target }, title))),
                    coverImage),
                React.createElement("div", { className: "arc-Card-children" },
                    React.createElement(Card.Block, null, children)),
                href && (React.createElement(CardBlock, null,
                    React.createElement(CardLink, { href: href, fill: fill, actionId: actionId, onClick: onClick, isButton: true }, actionLabel)))))));
};
/**
 * Internal `Card.Block` component to section blocks of content within a Card.
 */
var CardBlock = function (_a) {
    var _b = _a.align, align = _b === void 0 ? "left" : _b, children = _a.children, _c = _a.isFullWidth, isFullWidth = _c === void 0 ? false : _c, _d = _a.grow, grow = _d === void 0 ? false : _d;
    return (React.createElement("div", { className: classNames({
            "arc-Card-block": true,
            "arc-Card-block--alignCenter": align === "center",
            "arc-Card-block--alignRight": align === "right",
            "arc-Card-block--fullWidth": isFullWidth,
            "arc-Card-block--grow": grow
        }) },
        React.createElement("div", { className: "arc-Card-blockInner" }, children)));
};
CardBlock.displayName = "Card.Block";
Card.Block = CardBlock;
/**
 * Internal `Card.Image` component to show an image within a Card.
 */
var CardImage = function (_a) {
    var _b = _a.alt, alt = _b === void 0 ? "" : _b, _c = _a.height, height = _c === void 0 ? 176 : _c, loading = _a.loading, sizes = _a.sizes, src = _a.src, srcSet = _a.srcSet;
    return (React.createElement("div", { className: classNames({
            "arc-Card-image": true
        }) },
        React.createElement(Image, { alt: alt, fit: "cover", height: height, loading: loading, sizes: sizes, src: src, srcSet: srcSet })));
};
CardImage.displayName = "Card.Image";
Card.Image = CardImage;
/**
 * Internal `CardLink` component.
 */
var CardLink = function (_a) {
    var actionId = _a.actionId, isButton = _a.isButton, children = _a.children, fill = _a.fill, href = _a.href, _b = _a.linkData, linkData = _b === void 0 ? {} : _b, onClick = _a.onClick, stretch = _a.stretch, target = _a.target;
    var surface = useContext(Context$3).surface;
    return (React.createElement("a", __assign({ onClick: handleLinkClick({ handler: onClick }), "aria-describedby": actionId, className: classNames({
            "arc-Card-link": true,
            "arc-Card-link--button": isButton,
            "arc-Card-link--onDarkSurface": surface === "dark" && fill !== "neutral",
            "arc-Card-link--stretch": stretch
        }), href: href, rel: target === "_blank" ? "noopener noreferrer" : undefined, tabIndex: isButton ? -1 : undefined, target: target }, filterDataAttrs(linkData)),
        React.createElement("span", { className: "arc-Card-linkText" }, children),
        isButton && (React.createElement("span", { className: "arc-Card-linkIcon" },
            React.createElement(Icon, { icon: "btChevronRight2px", size: 8 })))));
};

var defaultContext$2 = {
    requirementStatus: null
};
var Context$2 = createContext(defaultContext$2);
var Provider$3 = Context$2.Provider;
/**
 * Use `FormControl` to provide inputs with labels, helper text and error messages
 */
var FormControl = function (_a) {
    var children = _a.children, _b = _a.elementType, ElementType = _b === void 0 ? "div" : _b, errorMessage = _a.errorMessage, helper = _a.helper, htmlFor = _a.htmlFor, id = _a.id, label = _a.label, _c = _a.labelSize, labelSize = _c === void 0 ? "l" : _c, _d = _a.requirementStatus, requirementStatus = _d === void 0 ? "optional" : _d, props = __rest(_a, ["children", "elementType", "errorMessage", "helper", "htmlFor", "id", "label", "labelSize", "requirementStatus"]);
    var surface = useContext(Context$3).surface;
    var _e = useAriaDescribedby({
        errorMessage: errorMessage,
        helper: helper,
        id: htmlFor || id // `htmlFor` is preference to keep this deterministic with TextInput
    }), ariaDescribedby = _e.ariaDescribedby, idError = _e.idError, idHelper = _e.idHelper;
    var LabelType = ElementType === "div" ? "label" : "legend";
    var elementProps = {};
    var labelProps = {};
    if (LabelType === "label") {
        labelProps["htmlFor"] = htmlFor;
        if (htmlFor) {
            labelProps["id"] = "".concat(htmlFor, "-label");
        }
        else if (id) {
            labelProps["id"] = "".concat(id, "-label");
        }
    }
    else {
        elementProps["aria-describedby"] = ariaDescribedby;
    }
    return (React.createElement(Provider$3, { value: { requirementStatus: requirementStatus } },
        React.createElement(ElementType, __assign({ className: classNames({
                "arc-FormControl": true,
                "arc-FormControl--smallLabel": labelSize === "s",
                "arc-FormControl--onDarkSurface": surface === "dark"
            }), id: id }, elementProps, filterDataAttrs(props)),
            React.createElement(LabelType, __assign({ className: "arc-FormControl-label" }, labelProps),
                label,
                requirementStatus === "optional" && (React.createElement("span", { className: "arc-FormControl-labelOptional" }, "(optional)"))),
            helper && (React.createElement("div", { className: "arc-FormControl-helper", id: idHelper }, helper)),
            children,
            errorMessage && (React.createElement("div", { className: "arc-FormControl-error", id: idError }, errorMessage)))));
};

/**
 *  Use `Checkbox` to allow users to select individual options.
 */
var Checkbox = forwardRef(function (_a, ref) {
    var _b = _a.checked, checked = _b === void 0 ? false : _b, errorMessage = _a.errorMessage, helper = _a.helper, id = _a.id, _c = _a.isDisabled, isDisabled = _c === void 0 ? false : _c, _d = _a.isRequired, isRequired = _d === void 0 ? false : _d, label = _a.label, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, _e = _a.size, size = _e === void 0 ? "l" : _e, value = _a.value, props = __rest(_a, ["checked", "errorMessage", "helper", "id", "isDisabled", "isRequired", "label", "name", "onBlur", "onChange", "size", "value"]);
    var requirementStatus = useContext(Context$2).requirementStatus;
    var surface = useContext(Context$3).surface;
    var _f = useAriaDescribedby({
        id: id,
        errorMessage: errorMessage
    }), ariaDescribedby = _f.ariaDescribedby, idError = _f.idError;
    var idLabel = "".concat(id, "-label");
    var checkedProps = {};
    if (typeof onChange === "function") {
        checkedProps.checked = checked;
    }
    else if (checked && !onChange) {
        checkedProps.defaultChecked = true;
    }
    if (requirementStatus === "required") {
        isRequired = true;
    }
    return (React.createElement("div", { className: classNames({
            "arc-Checkbox": true,
            "arc-Checkbox--disabled": isDisabled,
            "arc-Checkbox--invalid": errorMessage,
            "arc-Checkbox--small": size === "s",
            "arc-Checkbox--onDarkSurface": surface === "dark"
        }) },
        React.createElement("label", { id: idLabel, htmlFor: id, className: "arc-Checkbox-label" },
            React.createElement("input", __assign({ "aria-describedby": ariaDescribedby, "aria-invalid": errorMessage ? "true" : "false", className: "arc-Checkbox-input" }, checkedProps, { disabled: isDisabled, id: id, name: name, onBlur: onBlur, onChange: onChange, ref: ref, required: isRequired, type: "checkbox", value: value }, filterDataAttrs(props))),
            React.createElement("span", { className: "arc-Checkbox-box" }),
            React.createElement("span", null,
                label,
                !isRequired && requirementStatus !== "optional" ? (React.createElement("span", { className: "arc-Checkbox-labelOptional" }, "(optional)")) : null,
                helper && React.createElement("span", { className: "arc-Checkbox-helper" }, helper))),
        errorMessage && (React.createElement("div", { id: idError, className: "arc-Checkbox-error" }, errorMessage))));
});

/**
 * `Clock` is a demo component that shows the current time.
 */
var Clock = function (_a) {
    var _b = _a.locale, locale = _b === void 0 ? "en-GB" : _b, props = __rest(_a, ["locale"]);
    var _c = useState(new Date()), time = _c[0], setTime = _c[1];
    var _d = useState(time.toLocaleTimeString(locale)), humanTime = _d[0], setHumanTime = _d[1];
    useEffect(function () {
        var tick = function () {
            var newTime = new Date();
            setTime(newTime);
            setHumanTime(newTime.toLocaleTimeString(locale));
        };
        tick();
        var interval = setInterval(tick, 1000);
        return function () { return clearInterval(interval); };
    }, [locale]);
    return (React.createElement("time", __assign({ className: "arc-Clock", dateTime: time.toISOString() }, filterDataAttrs(props), { "data-locale": locale }), humanTime));
};

var Clock_rehydrator = (function (el) { return __awaiter(void 0, void 0, void 0, function () {
    var props;
    return __generator(this, function (_a) {
        props = {
            locale: el.dataset.locale
        };
        return [2 /*return*/, React.createElement(Clock, __assign({}, props))];
    });
}); });

/**
 * Use `Columns` to compose layouts on a 12-column grid.
 */
var Columns = function (_a) {
    var children = _a.children, _b = _a.isGutterless, isGutterless = _b === void 0 ? false : _b, props = __rest(_a, ["children", "isGutterless"]);
    useEffect(function () {
        React.Children.map(children, function (item) {
            if (item && item.type !== Col) {
                throw new Error("Illegal child passed to <Columns />. Ensure to only use <Columns.Col />.");
            }
        });
    }, [children]);
    return (React.createElement("div", __assign({ className: classNames({
            "arc-Columns": true,
            "arc-Columns--gutterless": isGutterless
        }) }, filterDataAttrs(props)),
        React.createElement("div", { className: "arc-Columns-inner" }, children)));
};
var Col = function (_a) {
    var _b;
    var align = _a.align, children = _a.children, _c = _a.isDebugVisible, isDebugVisible = _c === void 0 ? false : _c, offset = _a.offset, offsetS = _a.offsetS, offsetM = _a.offsetM, offsetL = _a.offsetL, offsetXL = _a.offsetXL, span = _a.span, spanS = _a.spanS, spanM = _a.spanM, spanL = _a.spanL, spanXL = _a.spanXL, props = __rest(_a, ["align", "children", "isDebugVisible", "offset", "offsetS", "offsetM", "offsetL", "offsetXL", "span", "spanS", "spanM", "spanL", "spanXL"]);
    return (React.createElement("div", __assign({ className: classNames((_b = {},
            _b["arc-Columns-col"] = true,
            _b[suffixModifier("arc-Columns-col--align", align || "")] = align,
            _b["arc-Columns-col--".concat(span)] = typeof span !== "undefined",
            _b["arc-Columns-col--s".concat(spanS)] = typeof spanS !== "undefined",
            _b["arc-Columns-col--m".concat(spanM)] = typeof spanM !== "undefined",
            _b["arc-Columns-col--l".concat(spanL)] = typeof spanL !== "undefined",
            _b["arc-Columns-col--xL".concat(spanXL)] = typeof spanXL !== "undefined",
            _b["arc-Columns-col--offset"] = typeof offset !== "undefined" ||
                typeof offsetS !== "undefined" ||
                typeof offsetM !== "undefined" ||
                typeof offsetL !== "undefined" ||
                typeof offsetXL !== "undefined",
            _b["arc-Columns-col--offset".concat(offset)] = typeof offset !== "undefined",
            _b["arc-Columns-col--offsetS".concat(offsetS)] = typeof offsetS !== "undefined",
            _b["arc-Columns-col--offsetM".concat(offsetM)] = typeof offsetM !== "undefined",
            _b["arc-Columns-col--offsetL".concat(offsetL)] = typeof offsetL !== "undefined",
            _b["arc-Columns-col--offsetXL".concat(offsetXL)] = typeof offsetXL !== "undefined",
            _b["arc-Columns-col--debugVisible"] = isDebugVisible,
            _b)) }, filterDataAttrs(props)), children));
};
Col.displayName = "Columns.Col";
Columns.Col = Col;

/**
 * Use `Curve` sparingly to soften edges and create a more natural, less rigid
 * look and feel.
 */
var Curve = function (_a) {
    var _b;
    var bottomColor = _a.bottomColor, _c = _a.from, from = _c === void 0 ? "top" : _c, _d = _a.isInverted, isInverted = _d === void 0 ? false : _d, _e = _a.size, size = _e === void 0 ? "m" : _e, topColor = _a.topColor, props = __rest(_a, ["bottomColor", "from", "isInverted", "size", "topColor"]);
    return (React.createElement("div", __assign({ className: classNames((_b = {
                "arc-Curve": true
            },
            _b[suffixModifier("arc-Curve--from", from)] = from && from !== "top",
            _b["arc-Curve--size".concat(size && size.toUpperCase())] = size && size !== "m",
            _b[suffixModifier("arc-Curve--bottomColor", bottomColor || "")] = bottomColor,
            _b[suffixModifier("arc-Curve--topColor", topColor || "")] = topColor,
            _b["arc-Curve--inverted"] = isInverted,
            _b)) }, filterDataAttrs(props))));
};

/**
 * Use `Disclosure` to display content that is only visible when toggled into
 * an "open" state.
 */
var Disclosure = function (_a) {
    var children = _a.children, headingLevel = _a.headingLevel, _b = _a.indentDetails, indentDetails = _b === void 0 ? false : _b, _c = _a.isOpen, isOpen = _c === void 0 ? false : _c, summary = _a.summary, props = __rest(_a, ["children", "headingLevel", "indentDetails", "isOpen", "summary"]);
    var surface = useContext(Context$3).surface;
    return (React.createElement("details", __assign({ className: classNames({
            "arc-Disclosure": true,
            "arc-Disclosure--indentDetails": indentDetails,
            "arc-Disclosure--onDarkSurface": surface === "dark"
        }), open: isOpen }, filterDataAttrs(props)),
        React.createElement("summary", { className: "arc-Disclosure-summary" },
            React.createElement(Heading, { level: headingLevel, size: "s" }, summary)),
        React.createElement("div", { className: "arc-Disclosure-details" }, children)));
};

/**
 * Use `Elevation` to elevate what matters.
 */
var Elevation = function (_a) {
    var _b;
    var children = _a.children, _c = _a.isFullWidth, isFullWidth = _c === void 0 ? false : _c, props = __rest(_a, ["children", "isFullWidth"]);
    return (React.createElement("div", __assign({ className: classNames((_b = {},
            _b["arc-Elevation"] = true,
            _b["arc-Elevation--fullWidth"] = isFullWidth,
            _b)) }, filterDataAttrs(props)), children));
};

/**
 * Use `Group` to arrange flexible items in a row.
 */
var Group = function (_a) {
    var _b;
    var children = _a.children, _c = _a.grow, grow = _c === void 0 ? false : _c, _d = _a.growEqual, growEqual = _d === void 0 ? false : _d, _e = _a.gutterBorder, gutterBorder = _e === void 0 ? false : _e, _f = _a.noWrap, noWrap = _f === void 0 ? false : _f, props = __rest(_a, ["children", "grow", "growEqual", "gutterBorder", "noWrap"]);
    var surface = useContext(Context$3).surface;
    useEffect(function () {
        React.Children.map(children, function (item) {
            if (item && item.type !== GroupItem) {
                throw new Error("Illegal child passed to <Group />. Ensure to only use <Group.Item />.");
            }
        });
    }, [children]);
    return (React.createElement("div", __assign({ className: classNames((_b = {},
            _b["arc-Group"] = true,
            _b["arc-Group--grow"] = grow,
            _b["arc-Group--growEqual"] = growEqual,
            _b["arc-Group--gutterBorder"] = gutterBorder,
            _b["arc-Group--noWrap"] = noWrap,
            _b["arc-Group--onDarkSurface"] = surface === "dark",
            _b)) }, filterDataAttrs(props)),
        React.createElement("div", { className: "arc-Group-inner" }, children)));
};
var GroupItem = function (_a) {
    var _b;
    var children = _a.children, _c = _a.grow, grow = _c === void 0 ? false : _c, _d = _a.isDebugVisible, isDebugVisible = _d === void 0 ? false : _d, props = __rest(_a, ["children", "grow", "isDebugVisible"]);
    return (React.createElement("div", __assign({ className: classNames((_b = {},
            _b["arc-Group-item"] = true,
            _b["arc-Group-item--grow"] = grow,
            _b["arc-Group-item--debugVisible"] = isDebugVisible,
            _b)) }, filterDataAttrs(props)), children));
};
GroupItem.displayName = "Group.Item";
Group.Item = GroupItem;

/**
 * Use `Markup` to display HTML-formatted text.
 */
var Markup = function (_a) {
    var children = _a.children, _b = _a.isMeasured, isMeasured = _b === void 0 ? false : _b, props = __rest(_a, ["children", "isMeasured"]);
    var surface = useContext(Context$3).surface;
    return (React.createElement("div", __assign({ className: classNames({
            "arc-Markup": true,
            "arc-Markup--measured": isMeasured,
            "arc-Markup--onDarkSurface": surface === "dark"
        }) }, filterDataAttrs(props)), children));
};

/**
 * Use `UniversalHeader` to display a group-level page header.
 */
var UniversalHeader = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    useEffect(function () {
        React.Children.map(children, function (item) {
            if (item && item.type !== UniversalHeaderItem) {
                throw new Error("Illegal child passed to <UniversalHeader />. Ensure to only use <UniversalHeader.Item />.");
            }
        });
    }, [children]);
    return (React.createElement("nav", __assign({ className: "arc-UniversalHeader" }, filterDataAttrs(props)),
        React.createElement(Surface, { background: "light" },
            React.createElement("ul", { className: "arc-UniversalHeader-items" }, children))));
};
var UniversalHeaderItem = function (_a) {
    var children = _a.children, href = _a.href, props = __rest(_a, ["children", "href"]);
    return (React.createElement("li", __assign({}, filterDataAttrs(props)),
        React.createElement("a", { className: "arc-UniversalHeader-link", href: href }, children)));
};
UniversalHeaderItem.displayName = "UniversalHeader.Item";
UniversalHeader.Item = UniversalHeaderItem;

var PosterImage = function (_a) {
    var alt = _a.alt, _b = _a.anchor, anchor = _b === void 0 ? "C" : _b, loading = _a.loading, sizes = _a.sizes, src = _a.src, srcSet = _a.srcSet, props = __rest(_a, ["alt", "anchor", "loading", "sizes", "src", "srcSet"]);
    return (React.createElement(Image, __assign({ alt: alt, anchor: anchor, fit: "cover", loading: loading, sizes: sizes, src: src, srcSet: srcSet }, props)));
};
PosterImage.displayName = "Poster.Image";

var PosterVideo = function (_a) {
    var _b;
    var _c = _a.anchor, anchor = _c === void 0 ? "C" : _c, _d = _a.autoPlay, autoPlay = _d === void 0 ? true : _d, children = _a.children, _e = _a.loop, loop = _e === void 0 ? true : _e, props = __rest(_a, ["anchor", "autoPlay", "children", "loop"]);
    return (React.createElement("video", __assign({ className: classNames((_b = {
                "arc-PosterVideo": true
            },
            _b[suffixModifier("arc-PosterVideo--anchor", anchor)] = anchor,
            _b)), autoPlay: autoPlay, muted: true, loop: loop }, filterDataAttrs(props)), children));
};
PosterVideo.displayName = "Poster.Video";

/**
 * Use `Poster` to compose content on an image or video background.
 */
var Poster = function (_a) {
    var background = _a.background, children = _a.children, _b = _a.overlay, overlay = _b === void 0 ? true : _b, _c = _a.surface, surface = _c === void 0 ? "darker" : _c, props = __rest(_a, ["background", "children", "overlay", "surface"]);
    return (React.createElement(Surface, { background: surface },
        React.createElement("div", __assign({ className: classNames({
                "arc-Poster": true,
                "arc-Poster--overlay": overlay,
                "arc-Poster--overlayLight": surface === "lighter"
            }) }, filterDataAttrs(props)),
            React.createElement("div", { className: "arc-Poster-backgroundWrapper" }, background),
            React.createElement("div", { className: "arc-Poster-body" }, children))));
};
PosterImage.displayName = "Poster.Image";
Poster.Image = PosterImage;
PosterVideo.displayName = "Poster.Video";
Poster.Video = PosterVideo;

var RadioContext = createContext({});
var Provider$2 = RadioContext.Provider;
var useRadioContext = function () {
    var context = useContext(RadioContext);
    return context;
};

/**
 * Radio Button component.
 */
var RadioButton = forwardRef(function (_a, ref) {
    var helper = _a.helper, id = _a.id, isDisabled = _a.isDisabled, label = _a.label, value = _a.value, props = __rest(_a, ["helper", "id", "isDisabled", "label", "value"]);
    var _b = useRadioContext(), blurEvent = _b.blurEvent, changeEvent = _b.changeEvent, groupDisabled = _b.groupDisabled, checkedValue = _b.checkedValue, labelSize = _b.labelSize, name = _b.name, size = _b.size;
    var surface = useContext(Context$3).surface;
    var idLabel = "".concat(id, "-label");
    var checked = checkedValue === value ? true : false;
    return (React.createElement("div", __assign({ className: classNames({
            "arc-RadioButton": true,
            "arc-RadioButton--disabled": isDisabled || groupDisabled,
            "arc-RadioButton--small": size === "s",
            "arc-RadioButton--smallLabel": labelSize === "s",
            "arc-RadioButton--onDarkSurface": surface === "dark"
        }) }, filterDataAttrs(props)),
        React.createElement("label", { className: "arc-RadioButton-label", htmlFor: id, id: idLabel },
            React.createElement("input", { className: "arc-RadioButton-input", checked: typeof changeEvent !== "function" ? undefined : checked, defaultChecked: typeof changeEvent !== "function" ? checked : undefined, disabled: isDisabled || groupDisabled, id: id, name: name, onBlur: blurEvent, onChange: changeEvent, ref: ref, type: "radio", value: value }),
            React.createElement("span", null,
                label,
                helper && React.createElement("span", { className: "arc-RadioButton-helper" }, helper)))));
});

/**
 * Use `RadioGroup` to wrap and control radio buttons and apply default values
 */
var RadioGroup = function (_a) {
    var children = _a.children, checkedValue = _a.checkedValue, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, id = _a.id, helper = _a.helper, label = _a.label, _c = _a.labelSize, labelSize = _c === void 0 ? "l" : _c, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, _d = _a.size, size = _d === void 0 ? "l" : _d, props = __rest(_a, ["children", "checkedValue", "isDisabled", "id", "helper", "label", "labelSize", "name", "onBlur", "onChange", "size"]);
    useEffect(function () {
        React.Children.map(children, function (item) {
            if (item && item.type !== RadioButton) {
                throw new Error("Illegal child passed to <RadioGroup />. Ensure to only use <RadioGroup.RadioButton />.");
            }
        });
    }, [children]);
    return (React.createElement(Provider$2, { value: {
            blurEvent: onBlur,
            changeEvent: onChange,
            groupDisabled: isDisabled,
            checkedValue: checkedValue,
            labelSize: labelSize,
            name: name,
            size: size
        } },
        React.createElement("div", __assign({ className: "arc-RadioGroup" }, filterDataAttrs(props)),
            React.createElement(FormControl, { elementType: "fieldset", label: label, labelSize: labelSize, helper: helper, id: id, requirementStatus: "not-applicable" }, children))));
};
RadioButton.displayName = "RadioGroup.RadioButton";
RadioGroup.RadioButton = RadioButton;

/**
 * Use `Rule` to display a horizontal rule.
 */
var Rule = function (props) {
    var surface = useContext(Context$3).surface;
    return (React.createElement("hr", __assign({ className: classNames({
            "arc-Rule": true,
            "arc-Rule--onDarkSurface": surface === "dark"
        }) }, filterDataAttrs(props))));
};

/**
 * Use `Section` to compose content into vertical page layouts.
 */
var Section = function (_a) {
    var children = _a.children, _b = _a.isFullWidth, isFullWidth = _b === void 0 ? false : _b, _c = _a.isDebugVisible, isDebugVisible = _c === void 0 ? false : _c, props = __rest(_a, ["children", "isFullWidth", "isDebugVisible"]);
    return (React.createElement("div", __assign({ className: classNames({
            "arc-Section": true,
            "arc-Section--fullWidth": isFullWidth,
            "arc-Section--debugVisible": isDebugVisible
        }) }, filterDataAttrs(props)), children));
};

/**
 * Use `SiteFooter` to display information at the bottom of a page.
 */
var SiteFooter = function (_a) {
    var children = _a.children, currentYear = _a.currentYear, _b = _a.curve, curve = _b === void 0 ? true : _b, logoLabel = _a.logoLabel, main = _a.main, siteName = _a.siteName, props = __rest(_a, ["children", "currentYear", "curve", "logoLabel", "main", "siteName"]);
    useEffect(function () {
        React.Children.map(children, function (item) {
            if (item && item.type !== SiteFooterItem) {
                throw new Error("Illegal child passed to <SiteFooter />. Ensure to only use <SiteFooter.Item />.");
            }
        });
    }, [children]);
    return (React.createElement(React.Fragment, null,
        curve ? (React.createElement(Curve, { bottomColor: "brand-flat", from: "topLeft", size: "s" })) : null,
        React.createElement("footer", __assign({ className: "arc-SiteFooter" }, filterDataAttrs(props)),
            React.createElement(Surface, { background: "brand-flat", paddingVertical: "24" },
                (siteName || main) && (React.createElement(React.Fragment, null,
                    React.createElement(Section, null,
                        siteName && (React.createElement("div", { className: "arc-SiteFooter-name" }, siteName)),
                        main && React.createElement("div", { className: "arc-SiteFooter-main" }, main)),
                    React.createElement("hr", { className: "arc-SiteFooter-rule" }))),
                React.createElement(Section, null,
                    React.createElement("div", { className: "arc-SiteFooter-secondary" },
                        children && (React.createElement("ul", { className: "arc-SiteFooter-secondaryItems" }, children)),
                        React.createElement("div", { className: "arc-SiteFooter-brand" },
                            React.createElement("div", { className: "arc-SiteFooter-copyright" },
                                React.createElement("span", { className: "arc-SiteFooter-copyrightSymbol" }, "\u00A9"), " ".concat(currentYear || new Date().getFullYear())),
                            React.createElement(BrandLogo, { label: logoLabel }))))))));
};
var SiteFooterItemGroup = function (_a) {
    var children = _a.children, title = _a.title;
    var isMinWidthArcBreakpointM = useMediaQuery("(min-width: ".concat(ArcBreakpointM, "px)"));
    useEffect(function () {
        React.Children.map(children, function (item) {
            if (item && item.type !== SiteFooterItem && item.type !== Fragment) {
                throw new Error("Illegal child passed to <SiteFooterItemGroup />. Ensure to only use <SiteFooter.Item />.");
            }
        });
    }, [children]);
    return (React.createElement("details", { className: "arc-SiteFooter-disclosure", open: isMinWidthArcBreakpointM },
        React.createElement("summary", { className: "arc-SiteFooter-summary", tabIndex: isMinWidthArcBreakpointM ? -1 : 0 },
            React.createElement("h2", { className: "arc-SiteFooter-title" }, title)),
        React.createElement("ul", { className: "arc-SiteFooter-mainItems" }, children)));
};
var SiteFooterItem = function (_a) {
    var children = _a.children, href = _a.href, onClick = _a.onClick, props = __rest(_a, ["children", "href", "onClick"]);
    return (React.createElement("li", __assign({ className: "arc-SiteFooter-item" }, filterDataAttrs(props)),
        React.createElement("a", { onClick: handleLinkClick({ handler: onClick }), className: "arc-SiteFooter-link", href: href }, children)));
};
SiteFooterItem.displayName = "SiteFooter.Item";
SiteFooter.Item = SiteFooterItem;
SiteFooterItemGroup.displayName = "SiteFooter.ItemGroup";
SiteFooter.ItemGroup = SiteFooterItemGroup;

var SiteFooter_rehydrator = (function (el, rehydrateChildren) { return __awaiter(void 0, void 0, void 0, function () {
    var children, titleElement, title, props;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, rehydrateChildren(el.querySelector(".arc-SiteFooter-mainItems"))];
            case 1:
                children = _a.sent();
                titleElement = el.querySelector(".arc-SiteFooter-title");
                title = "";
                if (titleElement) {
                    title = titleElement.textContent || /* istanbul ignore next */ "";
                }
                props = {
                    children: children,
                    title: title
                };
                return [2 /*return*/, React.createElement(SiteFooter.ItemGroup, __assign({}, props), children)];
        }
    });
}); });

var Item = function (_a) {
    var _b;
    var children = _a.children, href = _a.href, isEmphasised = _a.isEmphasised, onClick = _a.onClick, props = __rest(_a, ["children", "href", "isEmphasised", "onClick"]);
    return (React.createElement("li", __assign({ className: classNames((_b = {},
            _b["arc-SiteHeaderItem"] = true,
            _b["arc-SiteHeaderItem--emphasised"] = isEmphasised,
            _b)) }, filterDataAttrs(props)),
        React.createElement("a", { onClick: handleLinkClick({ handler: onClick }), className: "arc-SiteHeaderItem-link", href: href }, children)));
};

var ItemGroup = function (_a) {
    var children = _a.children, href = _a.href, title = _a.title, onClick = _a.onClick, viewAllTitle = _a.viewAllTitle, props = __rest(_a, ["children", "href", "title", "onClick", "viewAllTitle"]);
    var _b = useState(false), hasClientSideJavaScript = _b[0], setHasClientSideJavaScript = _b[1];
    var isMinWidthArcBreakpointL = useMediaQuery("(min-width: ".concat(ArcBreakpointL, "px)"));
    useEffect(function () {
        React.Children.map(children, function (item) {
            if (item && item.type !== Item && item.type !== Fragment) {
                throw new Error("Illegal child passed to <SiteHeader.ItemGroup />. Ensure to only use <SiteHeader.Item />.");
            }
        });
    }, [children]);
    useEffect(function () {
        // useEffect does not run in ReactDomServer renders
        setHasClientSideJavaScript(true);
    }, [setHasClientSideJavaScript]);
    var ElementType = "div";
    if (title) {
        ElementType = "details";
    }
    return (React.createElement("li", { className: "arc-SiteHeaderItemGroup" },
        React.createElement(ElementType, __assign({ className: "arc-SiteHeaderItemGroup-details", open: Boolean(title && isMinWidthArcBreakpointL) }, filterDataAttrs(props)),
            title ? (React.createElement("summary", { className: "arc-SiteHeaderItemGroup-summary", tabIndex: isMinWidthArcBreakpointL ? -1 : 0 }, href ? (React.createElement("a", { onClick: handleLinkClick({
                    handler: onClick
                }), className: "arc-SiteHeaderItemGroup-title", href: href, tabIndex: !hasClientSideJavaScript || isMinWidthArcBreakpointL ? 0 : -1 }, title)) : (React.createElement("div", { className: "arc-SiteHeaderItemGroup-title" }, title)))) : null,
            React.createElement("ul", { className: "arc-SiteHeaderItemGroup-items" },
                children,
                href && title ? (React.createElement("li", { className: "arc-SiteHeaderItem arc-SiteHeaderItem--viewAll" },
                    React.createElement("a", { className: "arc-SiteHeaderItem-link", onClick: handleLinkClick({
                            handler: onClick
                        }), href: href }, viewAllTitle || "View all ".concat(title.toLowerCase())))) : null))));
};

var ItemGroupRehydrator = (function (el, hydrate) { return __awaiter(void 0, void 0, void 0, function () {
    var children, titleElement, viewAllElement, title, href, viewAllTitle, props;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, hydrate(el.querySelector(".arc-SiteHeaderItemGroup-items"))];
            case 1:
                children = _a.sent();
                titleElement = el.querySelector(".arc-SiteHeaderItemGroup-title");
                viewAllElement = el.querySelector(".arc-SiteHeaderItem--viewAll");
                title = "";
                href = "";
                viewAllTitle = "";
                if (titleElement) {
                    title = titleElement.textContent || /* istanbul ignore next */ "";
                    href = titleElement.getAttribute("href") || /* istanbul ignore next */ "";
                }
                if (viewAllElement) {
                    viewAllTitle = viewAllElement.textContent || /* istanbul ignore next */ "";
                }
                props = {
                    children: children,
                    href: href,
                    title: title,
                    viewAllTitle: viewAllTitle
                };
                return [2 /*return*/, React.createElement(ItemGroup, __assign({}, props), children)];
        }
    });
}); });

var Column = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    useEffect(function () {
        React.Children.map(children, function (item) {
            if (item && item.type !== ItemGroup) {
                throw new Error("Illegal child passed to <SiteHeader.Column />. Ensure to only use <SiteHeader.ItemGroup />.");
            }
        });
    }, [children]);
    return (React.createElement("li", __assign({ className: "arc-SiteHeaderColumn" }, filterDataAttrs(props)),
        React.createElement("ul", { className: "arc-SiteHeaderColumn-items" }, children)));
};

var BackButton = function (_a) {
    var setOpen = _a.setOpen;
    return (React.createElement("button", { className: "arc-SiteHeaderBackButton", onClick: function () {
            setOpen(false);
        } },
        React.createElement("span", { className: "arc-SiteHeaderBackButton-text" }, "Back")));
};

var Panel = function (_a) {
    var _b;
    var children = _a.children, navItemRef = _a.navItemRef, open = _a.open, promo = _a.promo, setOpen = _a.setOpen, subNavItemRef = _a.subNavItemRef, _c = _a.subNavLink, subNavLink = _c === void 0 ? "" : _c, title = _a.title, viewAll = _a.viewAll, withSubNav = _a.withSubNav, props = __rest(_a, ["children", "navItemRef", "open", "promo", "setOpen", "subNavItemRef", "subNavLink", "title", "viewAll", "withSubNav"]);
    var transparent = useContext(Context).transparent;
    useEffect(function () {
        // Where appropriate, close the Panel when clicking outside of it,
        // by listening to clicks on the entire document and acting accordingly.
        var handleClick = function (e) {
            var _a, _b;
            // Don't close the Panel…
            if (
            // The click is inside the current SubNavItem.
            ((_a = subNavItemRef === null || subNavItemRef === void 0 ? void 0 : subNavItemRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) ||
                // The click is inside the current NavItem
                // and the Panel is not inside a SubNavItem.
                // and the target is not a link
                (((_b = navItemRef === null || navItemRef === void 0 ? void 0 : navItemRef.current) === null || _b === void 0 ? void 0 : _b.contains(e.target)) &&
                    !subNavItemRef &&
                    !e.target.getAttribute("href")) ||
                // The Panel is inside a SubNavItem
                // and the click is not on a SubNavItem-link.
                // This ensures that one SubNavItem Panel per NavItem always remains open.
                (subNavItemRef &&
                    !e.target.classList.contains(subNavLink) &&
                    !e.target.classList.contains("".concat(subNavLink, "Title")) &&
                    !e.target.classList.contains("".concat(subNavLink, "SubTitle"))) ||
                // Panel is inside a SubNavItem
                // and the click is not inside the Panel's NavItem parent.
                // This prevents SubNavItem Panels in sibling NavItems from being closed.
                (subNavItemRef && !(navItemRef === null || navItemRef === void 0 ? void 0 : navItemRef.current.contains(e.target)))) {
                return;
            }
            // Close the panel.
            setOpen(false);
        };
        document.addEventListener("click", handleClick);
        return function () {
            document.removeEventListener("click", handleClick);
        };
    }, [navItemRef, setOpen, subNavItemRef, subNavLink]);
    useEffect(function () {
        var handleKeydown = function (e) {
            // Check the viewport width at time of press
            var isMinWidthArcBreakpointL = window.matchMedia("(min-width: ".concat(ArcBreakpointL, "px)")).matches;
            if (e.key === "Escape" || e.keyCode === 27) {
                if (isMinWidthArcBreakpointL && subNavItemRef) {
                    // Don't close Panels inside SubNavItems when viewport width is above
                    // the "desktop" breakpoint.
                    return false;
                }
                return setOpen(false);
            }
        };
        window.addEventListener("keydown", handleKeydown);
        return function () {
            window.removeEventListener("keydown", handleKeydown);
        };
    }, [setOpen, subNavItemRef]);
    return (React.createElement("div", __assign({ className: classNames((_b = {},
            _b["arc-SiteHeaderPanel"] = true,
            _b["arc-SiteHeaderPanel--open"] = open,
            _b["arc-SiteHeaderPanel--transparent"] = transparent,
            _b["arc-SiteHeaderPanel--withSubNav"] = withSubNav,
            _b)) }, filterDataAttrs(props)),
        React.createElement(Surface, { background: "white", growVertically: true },
            React.createElement(BackButton, { setOpen: setOpen }),
            React.createElement("div", { className: "arc-SiteHeaderPanel-inner" },
                React.createElement("div", { className: "arc-SiteHeaderPanel-main" },
                    React.createElement("div", { className: "arc-SiteHeaderPanel-mainInner" },
                        withSubNav && (React.createElement("div", { className: "arc-SiteHeaderPanel-subNavArea" })),
                        title && (React.createElement("div", { className: "arc-SiteHeaderPanel-title" }, title)),
                        React.createElement("ul", { className: "arc-SiteHeaderPanel-items" }, children)),
                    viewAll),
                promo && React.createElement("div", { className: "arc-SiteHeaderPanel-promo" }, promo)))));
};
var ViewAll = function (_a) {
    var href = _a.href, title = _a.title, onClick = _a.onClick;
    return (React.createElement("a", { onClick: handleLinkClick({ handler: onClick }), className: "arc-SiteHeaderPanel-viewAll", href: href }, title));
};
ViewAll.displayName = "Panel.ViewAll";
Panel.ViewAll = ViewAll;

var NavItem = function (_a) {
    var _b, _c;
    var children = _a.children, href = _a.href, isCurrent = _a.isCurrent, onClick = _a.onClick, promo = _a.promo, title = _a.title, viewAllTitle = _a.viewAllTitle, props = __rest(_a, ["children", "href", "isCurrent", "onClick", "promo", "title", "viewAllTitle"]);
    var navItem = useRef();
    var _d = useState(false), panelOpen = _d[0], setPanelOpen = _d[1];
    useEffect(function () {
        React.Children.map(children, function (item) {
            if (item &&
                item.type !== ItemGroup &&
                item.type !== Column &&
                item.type !== Fragment) {
                throw new Error("Illegal child passed to <SiteHeader.NavItem />. Ensure to only use <SiteHeader.ItemGroup /> or <SiteHeader.Column />.");
            }
        });
    }, [children]);
    return (React.createElement("li", __assign({ className: classNames((_b = {},
            _b["arc-SiteHeaderNavItem"] = true,
            _b["arc-SiteHeaderNavItem--linkSelected"] = (children && panelOpen) || (!children && href && isCurrent),
            _b)), ref: navItem }, filterDataAttrs(props)), !children ? (href ? (React.createElement("a", { onClick: handleLinkClick({
            handler: onClick
        }), className: "arc-SiteHeaderNavItem-link", href: href }, title)) : null) : (React.createElement(React.Fragment, null,
        React.createElement("button", { "aria-expanded": panelOpen, className: classNames((_c = {},
                _c["arc-SiteHeaderNavItem-link"] = true,
                _c["arc-SiteHeaderNavItem-link--itemHasChildren"] = true,
                _c)), onClick: function (e) {
                e.preventDefault();
                setPanelOpen(!panelOpen);
            } }, title),
        React.createElement(Panel, { navItemRef: navItem, open: panelOpen, promo: promo, setOpen: setPanelOpen, viewAll: href ? (React.createElement(Panel.ViewAll, { href: href, onClick: onClick, title: viewAllTitle || "View all ".concat(title.toLowerCase()) })) : (undefined) }, children)))));
};

var NavItemRehydrator = (function (el, hydrate) { return __awaiter(void 0, void 0, void 0, function () {
    var children, promo, link, viewAll, href, title, props;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                children = el.querySelector(".arc-SiteHeaderPanel-items");
                promo = el.querySelector(".arc-SiteHeaderPanel-promo");
                if (!children) return [3 /*break*/, 2];
                return [4 /*yield*/, hydrate(children)];
            case 1:
                children = _a.sent();
                _a.label = 2;
            case 2:
                if (!promo) return [3 /*break*/, 4];
                return [4 /*yield*/, hydrate(promo)];
            case 3:
                promo = _a.sent();
                _a.label = 4;
            case 4:
                link = el.querySelector(".arc-SiteHeaderNavItem-link");
                viewAll = el.querySelector(".arc-SiteHeaderPanel-viewAll");
                href = "";
                title = "";
                if (link) {
                    title = link.textContent || /* istanbul ignore next */ "";
                    href = link.getAttribute("href") || /* istanbul ignore next */ "";
                }
                if (viewAll) {
                    href = viewAll.getAttribute("href") || /* istanbul ignore next */ "";
                }
                props = {
                    href: href,
                    isCurrent: el.classList.contains("arc-SiteHeaderNavItem--linkSelected") || undefined,
                    promo: promo || undefined,
                    title: title,
                    viewAllTitle: (viewAll === null || viewAll === void 0 ? void 0 : viewAll.textContent) || undefined
                };
                return [2 /*return*/, React.createElement(NavItem, __assign({}, props), children)];
        }
    });
}); });

/**
 * Use `Text` to display text.
 */
var Text = function (_a) {
    var _b;
    var _c = _a.align, align = _c === void 0 ? "left" : _c, children = _a.children, _d = _a.isInline, isInline = _d === void 0 ? false : _d, _e = _a.isMeasured, isMeasured = _e === void 0 ? false : _e, _f = _a.size, size = _f === void 0 ? "m" : _f, _g = _a.tone, tone = _g === void 0 ? "default" : _g, props = __rest(_a, ["align", "children", "isInline", "isMeasured", "size", "tone"]);
    var surface = useContext(Context$3).surface;
    return (React.createElement("span", __assign({ className: classNames((_b = {
                "arc-Text": true
            },
            _b[suffixModifier("arc-Text--align", align)] = align !== "left",
            _b["arc-Text--inline"] = isInline,
            _b["arc-Text--measured"] = isMeasured,
            _b["arc-Text--size".concat(size && size.toUpperCase())] = size && size !== "m",
            _b["arc-Text--".concat(tone)] = tone !== "default",
            _b["arc-Text--onDarkSurface"] = surface === "dark",
            _b)) }, filterDataAttrs(props)), children));
};

var SubNavItem = function (_a) {
    var _b, _c;
    var children = _a.children, _d = _a.isDefaultItem, isDefaultItem = _d === void 0 ? false : _d, href = _a.href, onClick = _a.onClick, offsetXL = _a.offsetXL, promo = _a.promo, subTitle = _a.subTitle, title = _a.title, viewAllTitle = _a.viewAllTitle, props = __rest(_a, ["children", "isDefaultItem", "href", "onClick", "offsetXL", "promo", "subTitle", "title", "viewAllTitle"]);
    var navItem = useContext(Context$1).navItem;
    var subNavItem = useRef();
    var _e = useState(false), panelOpen = _e[0], setPanelOpen = _e[1];
    var isMinWidthArcBreakpointL = useMediaQuery("(min-width: ".concat(ArcBreakpointL, "px)"));
    useEffect(function () {
        React.Children.map(children, function (item) {
            if (item &&
                item.type !== ItemGroup &&
                item.type !== Column &&
                item.type !== Fragment) {
                throw new Error("Illegal child passed to <SiteHeader.SubNavItem />. Ensure to only use <SiteHeader.ItemGroup /> or <SiteHeader.Column />.");
            }
        });
    }, [children]);
    useEffect(function () {
        if (isDefaultItem && isMinWidthArcBreakpointL) {
            setPanelOpen(true);
        }
        else {
            setPanelOpen(false);
        }
    }, [isDefaultItem, isMinWidthArcBreakpointL]);
    var linkTitle = (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "arc-SiteHeaderSubNavItem-linkTitle" }, title),
        subTitle ? (React.createElement("span", { className: "arc-SiteHeaderSubNavItem-linkSubTitle" }, subTitle)) : null));
    return (React.createElement("li", __assign({ className: classNames((_b = {},
            _b["arc-SiteHeaderSubNavItem"] = true,
            _b["arc-SiteHeaderSubNavItem--linkSelected"] = children && panelOpen,
            _b[suffixModifier("arc-SiteHeaderSubNavItem--offsetXL", offsetXL || "")] = offsetXL,
            _b)), ref: subNavItem }, filterDataAttrs(props), { "data-default-item": isDefaultItem || null }), !children ? (href ? (React.createElement("a", { className: "arc-SiteHeaderSubNavItem-link", onClick: handleLinkClick({ handler: onClick }), href: href }, linkTitle)) : null) : (React.createElement(React.Fragment, null,
        React.createElement("button", { "aria-expanded": panelOpen, className: classNames((_c = {},
                _c["arc-SiteHeaderSubNavItem-link"] = true,
                _c["arc-SiteHeaderSubNavItem-link--itemHasChildren"] = children,
                _c)), onClick: function () {
                setPanelOpen(true);
            } }, linkTitle),
        React.createElement(Panel, { navItemRef: navItem, open: panelOpen, setOpen: setPanelOpen, subNavItemRef: subNavItem, subNavLink: "arc-SiteHeaderSubNavItem-link", promo: promo, title: React.createElement("span", null,
                title,
                subTitle && (React.createElement(Text, { size: "xs", tone: "supporting" }, subTitle))), viewAll: href ? (React.createElement(Panel.ViewAll, { href: href, onClick: onClick, title: viewAllTitle || "View all ".concat(title.toLowerCase()) })) : (undefined) }, children)))));
};

var SubNavItemRehydrator = (function (el, hydrate) { return __awaiter(void 0, void 0, void 0, function () {
    var children, promo, link, linkTitle, viewAll, href, title, offsetXL, props;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                children = el.querySelector(".arc-SiteHeaderPanel-items");
                promo = el.querySelector(".arc-SiteHeaderPanel-promo");
                if (!children) return [3 /*break*/, 2];
                return [4 /*yield*/, hydrate(children)];
            case 1:
                children = _b.sent();
                _b.label = 2;
            case 2:
                if (!promo) return [3 /*break*/, 4];
                return [4 /*yield*/, hydrate(promo)];
            case 3:
                promo = _b.sent();
                _b.label = 4;
            case 4:
                link = el.querySelector(".arc-SiteHeaderSubNavItem-link");
                linkTitle = el.querySelector(".arc-SiteHeaderSubNavItem-linkTitle");
                viewAll = el.querySelector(".arc-SiteHeaderPanel-viewAll");
                href = "";
                title = "";
                if (link) {
                    href = link.getAttribute("href") || /* istanbul ignore next */ "";
                }
                if (linkTitle) {
                    title = linkTitle.textContent || /* istanbul ignore next */ "";
                }
                if (viewAll) {
                    href = viewAll.getAttribute("href") || /* istanbul ignore next */ "";
                }
                offsetXL = undefined;
                if (el.classList.contains("arc-SiteHeaderSubNavItem--offsetXL24")) {
                    offsetXL = "24";
                }
                if (el.classList.contains("arc-SiteHeaderSubNavItem--offsetXL48")) {
                    offsetXL = "48";
                }
                props = {
                    href: href,
                    isDefaultItem: Boolean(el.dataset.defaultItem),
                    offsetXL: offsetXL,
                    promo: promo || undefined,
                    subTitle: ((_a = el.querySelector(".arc-SiteHeaderSubNavItem-linkSubTitle")) === null || _a === void 0 ? void 0 : _a.textContent) ||
                        undefined,
                    title: title,
                    viewAllTitle: (viewAll === null || viewAll === void 0 ? void 0 : viewAll.textContent) || undefined
                };
                return [2 /*return*/, React.createElement(SubNavItem, __assign({}, props), children)];
        }
    });
}); });

var defaultContext$1 = { navItem: null, subTitle: null };
var Context$1 = createContext(defaultContext$1);
var Provider$1 = Context$1.Provider;
var NavItemWithSubNav = function (_a) {
    var _b, _c;
    var href = _a.href, slot1 = _a.slot1, slot2 = _a.slot2, slot3 = _a.slot3, _d = _a.subTitle, subTitle = _d === void 0 ? null : _d, title = _a.title, onViewAllClick = _a.onViewAllClick, viewAllTitle = _a.viewAllTitle, props = __rest(_a, ["href", "slot1", "slot2", "slot3", "subTitle", "title", "onViewAllClick", "viewAllTitle"]);
    var navItem = useRef();
    var _e = useState(true), defaultItem = _e[0], setDefaultItem = _e[1];
    var _f = useState(false), panelOpen = _f[0], setPanelOpen = _f[1];
    useEffect(function () {
        React.Children.map(slot1, function (item) {
            if (item && item.type !== SubNavItem && item.type !== Fragment) {
                throw new Error("Illegal child passed to <SiteHeader.NavItemWithSubNav /> `slot1` prop. Ensure to only use <SiteHeader.SubNavItem />.");
            }
            if (item.props.isDefaultItem) {
                setDefaultItem(false);
            }
        });
        React.Children.map(slot2, function (item) {
            if (item && item.type !== SubNavItem && item.type !== Fragment) {
                throw new Error("Illegal child passed to <SiteHeader.NavItemWithSubNav /> `slot2` prop. Ensure to only use <SiteHeader.SubNavItem />.");
            }
            if (item.props.isDefaultItem) {
                setDefaultItem(false);
            }
        });
        React.Children.map(slot3, function (item) {
            if (item && item.type !== SubNavItem && item.type !== Fragment) {
                throw new Error("Illegal child passed to <SiteHeader.NavItemWithSubNav /> `slot3` prop. Ensure to only use <SiteHeader.SubNavItem />.");
            }
            if (item.props.isDefaultItem) {
                setDefaultItem(false);
            }
        });
    }, [slot1, slot2, slot3]);
    return (React.createElement(Provider$1, { value: { navItem: navItem, subTitle: subTitle } },
        React.createElement("li", __assign({ className: classNames((_b = {},
                _b["arc-SiteHeaderNavItemWithSubNav"] = true,
                _b["arc-SiteHeaderNavItem--linkSelected"] = panelOpen,
                _b)), ref: navItem }, filterDataAttrs(props)),
            React.createElement("button", { "aria-expanded": panelOpen, className: classNames((_c = {},
                    _c["arc-SiteHeaderNavItem-link"] = true,
                    _c["arc-SiteHeaderNavItem-link--itemHasChildren"] = true,
                    _c)), onClick: function (e) {
                    e.preventDefault();
                    setPanelOpen(!panelOpen);
                } }, title),
            React.createElement(Panel, { navItemRef: navItem, open: panelOpen, setOpen: setPanelOpen, title: subTitle, viewAll: href ? (React.createElement(Panel.ViewAll, { href: href, onClick: onViewAllClick, title: viewAllTitle || "View all ".concat(title.toLowerCase()) })) : (undefined), withSubNav: true },
                defaultItem
                    ? React.cloneElement(slot1, { isDefaultItem: defaultItem })
                    : slot1,
                slot2,
                slot3))));
};

function wrap(el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
}
var NavItemWithSubNavRehydrator = (function (el, hydrate) { return __awaiter(void 0, void 0, void 0, function () {
    var subNavItem1, subNavItem2, subNavItem3, div1, div2, slot1, slot2, slot3, div3, link, subTitle, viewAllNodes, viewAll, title, props;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                subNavItem1 = el.querySelector(".arc-SiteHeaderSubNavItem:first-child");
                subNavItem2 = el.querySelector(".arc-SiteHeaderSubNavItem:nth-child(2)");
                subNavItem3 = el.querySelector(".arc-SiteHeaderSubNavItem:nth-child(3)");
                div1 = document.createElement("div");
                div1.className = "slot1";
                div2 = document.createElement("div");
                div2.className = "slot2";
                wrap(subNavItem1, div1);
                wrap(subNavItem2, div2);
                return [4 /*yield*/, hydrate(el.querySelector(".slot1"))];
            case 1:
                slot1 = _a.sent();
                return [4 /*yield*/, hydrate(el.querySelector(".slot2"))];
            case 2:
                slot2 = _a.sent();
                if (!subNavItem3) return [3 /*break*/, 4];
                div3 = document.createElement("div");
                div3.className = "slot3";
                wrap(subNavItem3, div3);
                return [4 /*yield*/, hydrate(el.querySelector(".slot3"))];
            case 3:
                slot3 = _a.sent();
                _a.label = 4;
            case 4:
                link = el.querySelector(".arc-SiteHeaderNavItem-link");
                subTitle = el.querySelector(".arc-SiteHeaderPanel-title");
                viewAllNodes = el.querySelectorAll(".arc-SiteHeaderPanel-viewAll");
                viewAll = viewAllNodes[viewAllNodes.length - 1];
                title = "";
                if (link) {
                    title = link.textContent || /* istanbul ignore next */ "";
                }
                props = {
                    href: (viewAll === null || viewAll === void 0 ? void 0 : viewAll.getAttribute("href")) || undefined,
                    slot1: slot1 || /* istanbul ignore next */ undefined,
                    slot2: slot2 || /* istanbul ignore next */ undefined,
                    slot3: slot3 || undefined,
                    subTitle: (subTitle === null || subTitle === void 0 ? void 0 : subTitle.textContent) || undefined,
                    title: title,
                    viewAllTitle: (viewAll === null || viewAll === void 0 ? void 0 : viewAll.textContent) || undefined
                };
                return [2 /*return*/, React.createElement(NavItemWithSubNav, __assign({}, props))];
        }
    });
}); });

var MenuButton = function (_a) {
    var _b;
    var menuOpen = _a.menuOpen, setMenuOpen = _a.setMenuOpen;
    return (React.createElement("button", { "aria-expanded": menuOpen, className: classNames((_b = {},
            _b["arc-MenuButton"] = true,
            _b["arc-MenuButton--menuOpen"] = menuOpen,
            _b)), onClick: function () {
            setMenuOpen(!menuOpen);
        }, type: "button" },
        React.createElement("span", { className: "arc-MenuButton-box" },
            React.createElement("span", { className: "arc-MenuButton-inner" }),
            React.createElement("span", { className: "arc-MenuButton-text" }, "Menu"))));
};

var defaultContext = { transparent: false };
var Context = createContext(defaultContext);
var Provider = Context.Provider;
/**
 * Use `SiteHeader` to display brand logo and navigation at the top of a page.
 */
var SiteHeader = function (_a) {
    var _b;
    var children = _a.children, basket = _a.basket, _c = _a.hasLogin, hasLogin = _c === void 0 ? true : _c, _d = _a.isTransparent, isTransparent = _d === void 0 ? false : _d, _e = _a.loginHref, loginHref = _e === void 0 ? "/login" : _e, logoOnClick = _a.logoOnClick, loginOnClick = _a.loginOnClick, _f = _a.loginTitle, loginTitle = _f === void 0 ? "Log in / Register" : _f, _g = _a.logoHref, logoHref = _g === void 0 ? "/" : _g, _h = _a.logoLabel, logoLabel = _h === void 0 ? "Home" : _h, search = _a.search, subBrand = _a.subBrand, props = __rest(_a, ["children", "basket", "hasLogin", "isTransparent", "loginHref", "logoOnClick", "loginOnClick", "loginTitle", "logoHref", "logoLabel", "search", "subBrand"]);
    var _j = useState(false), hasClientSideJavaScript = _j[0], setHasClientSideJavaScript = _j[1];
    var _k = useState(false), menuOpen = _k[0], setMenuOpen = _k[1];
    var isMinWidthArcBreakpointL = useMediaQuery("(min-width: ".concat(ArcBreakpointL, "px)"));
    useEffect(function () {
        React.Children.map(children, function (item) {
            if (item &&
                item.type !== NavItem &&
                item.type !== NavItemWithSubNav &&
                item.type !== Fragment) {
                throw new Error("Illegal child passed to <SiteHeader />. Ensure to only use <SiteHeader.NavItem /> or <SiteHeader.NavItemWithSubNav />");
            }
        });
    }, [children]);
    useEffect(function () {
        if (!isMinWidthArcBreakpointL && menuOpen) {
            document.body.classList.add("arc-body--overflowHidden");
        }
        else {
            document.body.classList.remove("arc-body--overflowHidden");
        }
        return function () {
            document.body.classList.remove("arc-body--overflowHidden");
        };
    }, [isMinWidthArcBreakpointL, menuOpen]);
    useEffect(function () {
        var handleKeydown = function (e) {
            if (e.key === "Escape" || e.keyCode === 27) {
                setMenuOpen(false);
            }
        };
        window.addEventListener("keydown", handleKeydown);
        return function () {
            window.removeEventListener("keydown", handleKeydown);
        };
    }, [setMenuOpen]);
    useEffect(function () {
        var handleClick = function (e) {
            if (e.target.getAttribute("href")) {
                setMenuOpen(false);
            }
        };
        document.addEventListener("click", handleClick);
        return function () {
            document.removeEventListener("click", handleClick);
        };
    }, [setMenuOpen]);
    useEffect(function () {
        // useEffect does not run in ReactDomServer renders
        setHasClientSideJavaScript(true);
    }, [setHasClientSideJavaScript]);
    return (React.createElement(Provider, { value: { transparent: isTransparent } },
        React.createElement("div", __assign({ className: classNames((_b = {},
                _b["arc-SiteHeader"] = true,
                _b["arc-SiteHeader--menuOpen"] = menuOpen,
                _b["arc-no-js"] = !hasClientSideJavaScript,
                _b)) }, filterDataAttrs(props), { "data-transparent": isTransparent || null }),
            React.createElement(Surface, { background: !isTransparent || (menuOpen && !isMinWidthArcBreakpointL)
                    ? "brand-flat"
                    : undefined },
                React.createElement("div", { className: "arc-SiteHeader-inner" },
                    React.createElement("a", { className: "arc-SiteHeader-brand", onClick: handleLinkClick({
                            handler: logoOnClick
                        }), href: logoHref },
                        React.createElement(BrandLogo, { label: logoLabel, subBrand: subBrand })),
                    children && (React.createElement("nav", { className: "arc-SiteHeader-nav" },
                        React.createElement("div", { className: "arc-SiteHeader-menuButton" },
                            React.createElement(MenuButton, { menuOpen: menuOpen, setMenuOpen: setMenuOpen })),
                        React.createElement("div", { className: "arc-SiteHeader-main" },
                            React.createElement("ul", { className: "arc-SiteHeader-navItems" }, children),
                            hasLogin && (React.createElement(React.Fragment, null, loginOnClick ? (React.createElement("div", { className: "arc-SiteHeader-loginButton" },
                                React.createElement(Button, { onClick: loginOnClick, isFullWidth: true, label: loginTitle }))) : (React.createElement("div", { className: "arc-SiteHeader-loginButton" },
                                React.createElement(Button, { href: loginHref, isFullWidth: true, label: loginTitle })))))))),
                    (basket || hasLogin || search) && (React.createElement("div", { className: "arc-SiteHeader-secondary" },
                        search ? (React.createElement("div", { className: "arc-SiteHeader-search" }, search)) : null,
                        basket ? (React.createElement("div", { className: "arc-SiteHeader-basket" }, basket)) : null,
                        hasLogin && (React.createElement(React.Fragment, null, loginOnClick ? (React.createElement("div", { className: "arc-SiteHeader-loginLink arc-SiteHeader-loginLink--function", onClick: loginOnClick }, loginTitle)) : (React.createElement("a", { className: "arc-SiteHeader-loginLink", href: loginHref }, loginTitle)))))))))));
};
Column.displayName = "SiteHeader.Column";
Item.displayName = "SiteHeader.Item";
ItemGroup.displayName = "SiteHeader.ItemGroup";
NavItem.displayName = "SiteHeader.NavItem";
NavItemWithSubNav.displayName = "SiteHeader.NavItemWithSubNav";
SubNavItem.displayName = "SiteHeader.SubNavItem";
SiteHeader.Column = Column;
SiteHeader.Item = Item;
SiteHeader.ItemGroup = ItemGroup;
SiteHeader.NavItem = NavItem;
SiteHeader.NavItemWithSubNav = NavItemWithSubNav;
SiteHeader.SubNavItem = SubNavItem;

var SiteHeaderRehydrator = function (el, hydrate) { return __awaiter(void 0, void 0, void 0, function () {
    var children, basket, search, brand, login, logoHref, logoLabel, props;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                children = el.querySelector(".arc-SiteHeader-navItems");
                basket = el.querySelector(".arc-SiteHeader-basket");
                search = el.querySelector(".arc-SiteHeader-search");
                if (!children) return [3 /*break*/, 2];
                return [4 /*yield*/, hydrate(children)];
            case 1:
                children = _a.sent();
                _a.label = 2;
            case 2:
                if (!basket) return [3 /*break*/, 4];
                return [4 /*yield*/, hydrate(basket)];
            case 3:
                basket = _a.sent();
                _a.label = 4;
            case 4:
                if (!search) return [3 /*break*/, 6];
                return [4 /*yield*/, hydrate(search)];
            case 5:
                search = _a.sent();
                _a.label = 6;
            case 6:
                brand = el.querySelector(".arc-SiteHeader-brand");
                login = el.querySelector(".arc-SiteHeader-loginLink");
                logoHref = "";
                logoLabel = "";
                if (brand) {
                    logoHref = brand.getAttribute("href") || /* istanbul ignore next */ "";
                    logoLabel = brand.textContent || /* istanbul ignore next */ "";
                }
                props = {
                    basket: basket,
                    hasLogin: Boolean(login),
                    isTransparent: Boolean(el.dataset.transparent),
                    loginHref: (login === null || login === void 0 ? void 0 : login.getAttribute("href")) || undefined,
                    loginTitle: (login === null || login === void 0 ? void 0 : login.textContent) || undefined,
                    logoHref: logoHref,
                    logoLabel: logoLabel,
                    search: search
                };
                return [2 /*return*/, React.createElement(SiteHeader, __assign({}, props), children)];
        }
    });
}); };
SiteHeaderRehydrator.ItemGroupRehydrator = ItemGroupRehydrator;
SiteHeaderRehydrator.NavItemRehydrator = NavItemRehydrator;
SiteHeaderRehydrator.NavItemWithSubNavRehydrator = NavItemWithSubNavRehydrator;
SiteHeaderRehydrator.SubNavItemRehydrator = SubNavItemRehydrator;

/**
 * Use `TextInput` to allow custom user text entry with a keyboard.
 */
var TextInput = forwardRef(function (_a, ref) {
    var _b = _a.defaultValue, defaultValue = _b === void 0 ? "" : _b, errorMessage = _a.errorMessage, helper = _a.helper, id = _a.id, inputMode = _a.inputMode, _c = _a.isDisabled, isDisabled = _c === void 0 ? false : _c, _d = _a.isReadOnly, isReadOnly = _d === void 0 ? false : _d, _e = _a.isRequired, isRequired = _e === void 0 ? false : _e, label = _a.label, _f = _a.labelSize, labelSize = _f === void 0 ? "l" : _f, maxLength = _a.maxLength, minLength = _a.minLength, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, pattern = _a.pattern, _g = _a.type, type = _g === void 0 ? "text" : _g, value = _a.value, props = __rest(_a, ["defaultValue", "errorMessage", "helper", "id", "inputMode", "isDisabled", "isReadOnly", "isRequired", "label", "labelSize", "maxLength", "minLength", "name", "onBlur", "onChange", "pattern", "type", "value"]);
    var surface = useContext(Context$3).surface;
    var inferredInputProps = useNumericInput({ inputMode: inputMode, pattern: pattern, type: type });
    // Although this is used within FormControlWrapper, it's deterministic so we can call it here too
    var ariaDescribedby = useAriaDescribedby({
        errorMessage: errorMessage,
        id: id,
        helper: helper
    }).ariaDescribedby;
    return (React.createElement("div", __assign({ className: classNames({
            "arc-TextInput": true,
            "arc-TextInput--invalid": errorMessage,
            "arc-TextInput--onDarkSurface": surface === "dark"
        }) }, filterDataAttrs(props)),
        React.createElement(FormControl, { errorMessage: errorMessage, helper: helper, htmlFor: id, label: label, labelSize: labelSize, requirementStatus: isRequired ? "required" : "optional" },
            React.createElement("input", __assign({ "aria-describedby": ariaDescribedby, "aria-invalid": errorMessage ? "true" : "false", className: "arc-TextInput-input", defaultValue: typeof value !== "undefined" ? undefined : defaultValue, disabled: isDisabled, id: id, maxLength: maxLength, minLength: minLength, name: name, onChange: onChange, onBlur: onBlur, readOnly: isReadOnly, ref: ref, required: isRequired, value: typeof value !== "undefined" ? value : undefined }, inferredInputProps)))));
});

/**
 * Use `VerticalSpace` to create vertical space between components.
 */
var VerticalSpace = function (_a) {
    var _b;
    var _c = _a.isDebugVisible, isDebugVisible = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? "24" : _d, props = __rest(_a, ["isDebugVisible", "size"]);
    return (React.createElement("div", __assign({ className: classNames((_b = {
                "arc-VerticalSpace": true
            },
            _b["arc-VerticalSpace--size".concat(size)] = size && size !== "24",
            _b["arc-VerticalSpace--debugVisible"] = isDebugVisible,
            _b)) }, filterDataAttrs(props))));
};

export { Align, Base, BrandLogo, Button, Card, Checkbox, Clock, Clock_rehydrator as ClockRehydrator, Columns, Curve, Disclosure, Elevation, FormControl, Group, Heading, Icon, Image, Markup, Poster, RadioGroup, Rule, Section, SiteFooter, SiteFooter_rehydrator as SiteFooterRehydrator, SiteHeader, SiteHeaderRehydrator, Surface, Context$3 as SurfaceContext, Text, TextInput, UniversalHeader, VerticalSpace };
//# sourceMappingURL=index.es.js.map
